React = require 'react'
ReactBacon = require 'react-bacon'
{Icon }= require 'react-fa'
R = require 'ramda'
cx = require 'classnames'
NavigationMixin = require 'components/lib/navigation'
PropTypes = require 'prop-types'
createReactClass = require 'create-react-class'
{withRouter} = require 'react-router-dom'
moment = require 'moment'
momentTz = require 'moment-timezone'
orderStore = require 'stores/order'
presenceStore = require 'stores/presence'
userStore = require 'stores/user'
{ Card, CardBody, CardHeader, CardFooter, CardColumns, CardLink, CardGroup } = require 'reactstrap'
ReactBacon = require 'react-bacon'
{ timeSlice } = require 'utils/time'
import Pagination from "react-js-pagination"

{ BaconMixin } = ReactBacon

{ shorten } = require 'zuppler-js/lib/utils/text'

Cards = createReactClass
  displayName: 'Cards'

  propTypes:
    list: PropTypes.object.isRequired
    selected: PropTypes.object
    currentOrderId: PropTypes.string
    columns: PropTypes.number.isRequired

  render: ->
    <div className="w-100">
      {@renderOrders()}
      {@renderPagination()}
    </div>

  renderOrders: ->
    <ListOrders list={@props.list} selected={@props.selected} currentOrderId={@props.currentOrderId} columns={@props.columns}/>

  renderPagination: ->
    <MetaPagination list={@props.list} />


ListOrders = createReactClass
  displayName: 'ListOrders'
  propTypes:
    list: PropTypes.object.isRequired
    selected: PropTypes.object
    currentOrderId: PropTypes.string
    columns: PropTypes.number.isRequired

  mixins: [BaconMixin]

  getInitialState: ->
    orders: []
    ordersToUsers: {}

  componentWillMount: ->
    @plug @props.list.orders, 'orders'
    @plug presenceStore.orders, 'ordersToUsers'

  render: ->
    if @props.columns > 1
      <div className="cards multiple">
        {R.map @renderCard, @state.orders}
      </div>
    else
      <div className="cards single">
        {R.map @renderCard, @state.orders}
      </div>

  renderCard: (order) ->
    # route param is authoritative - the legacy orderStore is not populated
    # when the v5 OrderPage handles the order
    active = order.uuid == @props.currentOrderId or (@props.selected and (order.uuid == @props.selected.id or order.uuid == @props.selected.uuid))
    users = @state.ordersToUsers[order.uuid] || []
    <OrderCard key={order.uuid} order={order} users={users} active={active} list={@props.list}></OrderCard>

OrderCard = createReactClass
  displayName: 'OrderCard'
  mixins: [ReactBacon.BaconMixin]
  propTypes:
    list: PropTypes.object.isRequired
    order: PropTypes.object.isRequired
    users: PropTypes.array
    active: PropTypes.bool

  onOpenOrder: ->
    @props.history.push "/lists/#{@props.list.id}/order/#{@props.order.uuid}"

  orderStateClass: ->
    state = @props.order.state
    timeValue = @props.order.order_at
    time = momentTz.tz(timeValue, userStore.timezone())

    cx "panel-#{state}-#{timeSlice(time)}", 'active': @props.active

  componentWillMount: ->
    @updateInterval = setInterval @forceUpdate.bind(@), 60*1000

  componentWillUnmount: ->
    clearInterval(@updateInterval)

  renderHeader: ->
    <div className="oc-head">
      <div className="oc-restaurant">
        { @renderStateIcon(@props.order.state) } { @renderPendingStateIcon(@props.order.pending) } { @props.order.restaurant_name && shorten @props.order.restaurant_name, 40, true }
      </div>
      <span className="oc-state">{@props.order.state}</span>
    </div>

  renderFooter: (users) ->
    timeValue = @props.order.order_at
    timeZonetime = momentTz.utc(timeValue).format()
    timeInfo = moment(timeZonetime).fromNow()
    if timeInfo == 'Invalid Date'
      timeInfo = null
    orderId = @props.order.uuid.split('-')[0]
    <span className="card-footer">
      <span key="p" className="oc-total">{ @renderTenderIcon(@props.order.card_type) } {(@props.order.total / 100).toFixed(2)}</span>
      <span key="c" className="oc-time"><Icon name="clock-o" /> { timeInfo }</span>
      <span key="t" className="oc-uuid"><Icon name="ticket" /> { orderId }</span>
      <span className="presence-info">{users}</span>
    </span>

  renderTenderIcon: (tender) ->
    switch tender
      when 'CASH', 'CARD_ON_DELIVERY', 'COD' then React.createElement(Icon, {"name": "money", "title": (tender)})
      when 'CARD', 'LEVELUP' then React.createElement(Icon, {"name": "credit-card", "title": (tender)})
      when 'BUCKID', 'ACCOUNT' then React.createElement(Icon, {"name": "google-wallet", "title": (tender)})
      when 'POINTS' then React.createElement(Icon, {"name": "dot-circle-o", "title": (tender)})
      when 'PAYPAL' then React.createElement(Icon, {"name": "paypal", "title": (tender)})
      when 'MOLLIE' then React.createElement(Icon, {"name": "cc-paypal", "title": (tender)})
      else React.createElement(Icon, {"name": "question-mark", "title": (tender)})

  renderStateIcon: (state) ->
    switch state
      when 'confirmed' then React.createElement(Icon, {"name": "check", "title": (state)})
      when 'invoiced' then React.createElement(Icon, {"name": "check-circle-o", "title": (state)})
      when 'missed' then React.createElement(Icon, {"name": "exclamation", "title": (state)})
      when 'canceled' then React.createElement(Icon, {"name": "remove", "title": (state)})
      when 'editing' then React.createElement(Icon, {"name": "pencil-square-o", "title": (state)})
      when 'captured' then React.createElement(Icon, {"name": "plus", "title": (state)})
      when 'executing' then React.createElement(Icon, {"name": "shopping-cart", "title": (state)})
      when 'created' then React.createElement(Icon, {"name": "plus-square-o", "title": (state)})
      when 'rejected' then React.createElement(Icon, {"name": "ban", "title": (state)})
      when 'prepared' then React.createElement(Icon, {"name": "check", "title": (state)})
      else React.createElement("span", null, React.createElement(Icon, {"name": "info"}), " ", ( state ))

  renderPendingStateIcon: (pending) ->
    if pending then React.createElement(Icon, {"name": "code-fork", "title": "Processing..."}) else null

  render: ->
    initials = R.compose(R.join(""), R.map((str)-> str.substring(0, 1)), R.split(/\s+/))
    roleToClass = R.map (n) -> "presence-role-#{n}"

    users = @props.users.map (u) ->
      className = cx "label", "label-default", roleToClass(u.roles).join(" ")
      <span key={u.email} className={className} title={u.user}>{initials u.user || "N A"}</span>

    <Card key={@props.order.uuid} className={@orderStateClass()}>
      <CardLink href= "#/lists/#{@props.list.id}/order/#{@props.order.uuid}">
        <CardHeader>
          {@renderHeader()}
        </CardHeader>
        <CardBody>
          <div className="oc-customer">
            <span key="name" className="customer-name">{@props.order.customer_name}</span>
            <span key="sid" className="order-type">{@props.order.order_type || 'N/A'}</span>
          </div>
        </CardBody>
        <CardFooter>
          {@renderFooter(users)}
        </CardFooter>
      </CardLink>
    </Card>

MetaPagination = createReactClass
  displayName: 'MetaPagination'
  mixins: [BaconMixin]
  propTypes:
    list: PropTypes.object.isRequired

  getInitialState: ->
    totalOrders: 0
    pageNumber: 0

  componentWillMount: ->
    @plug @props.list.totalOrders, 'totalOrders'
    @plug @props.list.pageNumber, 'pageNumber'

  selectPage: (pageNumber) ->
    @props.list.setPage pageNumber

  render: ->
    <Pagination
      prevPageText='prev'
      nextPageText='next'
      firstPageText='first'
      lastPageText='last'
      itemsCountPerPage={20}
      activePage={@state.pageNumber}
      pageRangeDisplayed={3}
      onChange={@selectPage}
      totalItemsCount = {@state.totalOrders}
      itemClass="page-item"
      linkClass="page-link"
      itemClassLast="hidden"
    />

module.exports = withRouter(Cards)
